import { NavLink, Link, useNavigate } from 'react-router-dom';

export default function LeftBar(props) {
    let items = props.data.map(item =>
        <li className="nav-item" key={item.id}>
            <Link className="nav-link" aria-current="page" to={item.path}>{item.name}</Link>
        </li>
    )
    return (
        <div className="fixed_left">
            <h3>{props.head}</h3>
            <ul className="nav flex-column">
                {items}
            </ul>
        </div>
    )
}